import api from '@/utils/axios/api';

export default {

  async login({ commit }, params) {
    const { data: { data: { tokens, user } } } = await api.post('/auth/login', params);

    commit('setToken', tokens);
    commit('setUser', user);
  },
  logout({ commit }) {
    commit('clearAuth');
  },

  async register(store, params) {
    await api.post('/auth/register', params);
  },

  /**
   * @param {String} token
   */
  async checkToken(state, { token }) {
    const { data: { data } } = await api.get(`/password/find/${token}`);

    return data;
  },

  /**
   * @param {String} email
   */
  async forgotPassword(state, { email }) {
    await api.post('/password/create', { email });
  },

  /**
   * @param {String} email
   * @param {String} token
   * @param {String} password
   * @param {String} passwordConfirmation
   */
  async resetPassword(state, {
    email,
    token,
    password,
    passwordConfirmation,
  }) {
    await api.post('/password/reset', {
      email,
      token,
      password,
      password_confirmation: passwordConfirmation,
    });
  },

};
